// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1019":"6aadaf17","5560":"f435787f","8285":"e5207859","8688":"6aadaf17","9453":"9ffaceec"}[chunkId] + ".chunk.css";
};